<template>
    <div>
        <v-expansion-panels class="mb-1">
                <v-expansion-panel>
                    <v-expansion-panel-header>
                        <div class="kpi-card-header">
                            <div class="kpi-card-top">
                                <span class="kpi-card-type">{{$t('pmreviewexercisesectioncard.commonkpi')}}</span>
                                <span class="kpi-card-weightage">{{$t('pmreviewexercisesectioncard.weightage')}}: {{commonkpi.weightage}}%</span>
                            </div>
                            <div class="kpi-card-goal">{{formData[0].goal}}</div>
                        </div>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content class="pa-0">
                        <div class="mx-4 mt-1 mb-2">
                            <v-row class="mt-0">
                                <v-col cols="3" sm="3" class="pb-n5">
                                    <v-text-field
                                        outlined
                                        :label="$t('columns.type')"
                                        type="text"
                                        ref="type"
                                        v-model="formData.type"
                                        dense
                                        readonly
                                        background-color="#ffeab2"
                                    ></v-text-field>
                                </v-col>
                            </v-row>

                            <v-row class="mt-n4">
                                <v-col cols="9" sm="9" class="mt-n2">
                                    <v-text-field
                                        outlined
                                        :label="$t('pmreviewexercisesectioncard.goal')"
                                        type="text"
                                        ref="goal"
                                        v-model="formData[0].goal"
                                        dense
                                        readonly
                                        background-color="#ffeab2"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="3" sm="3" class="mt-n2">
                                    <v-text-field
                                        outlined
                                        :label="$t('pmreviewexercisesectioncard.weightage')"
                                        type="number"
                                        ref="weightage"
                                        v-model="formData[0].weightage"
                                        dense
                                        readonly
                                        background-color="#ffeab2"
                                    ></v-text-field>
                                </v-col>
                            </v-row>

                            <v-row class="mt-n4">
                                <v-col cols="9" sm="9" class="mt-n2">
                                    <v-text-field
                                        class="kpi-field"
                                        outlined
                                        :label="$t('pmreviewexercisesectioncard.KPI')"
                                        type="text"
                                        ref="kpi"
                                        v-model="formData[0].kpi"
                                        dense
                                        readonly
                                        background-color="#ffeab2"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="3" sm="3" class="mt-n2">
                                    <v-text-field
                                        outlined
                                        :label="$t('pmreviewexercisesectioncard.progressInPercentage')"
                                        type="number"
                                        ref="progress"
                                        v-model="formData.progress"
                                        dense
                                        readonly
                                        background-color="#ffeab2"
                                    ></v-text-field>
                                </v-col>
                            </v-row>

                            <v-row class="mt-n4">
                                <v-col cols="4" sm="4" class="mt-n2">
                                    <v-autocomplete
                                        outlined
                                        :label="$t('performancemanagement.targetoption')"
                                        type="text"
                                        ref="pmtargetoptionid"
                                        v-model="formData[0].pmtargetoptionid"
                                        :items="targetOptionList"
                                        dense
                                        readonly
                                        background-color="#ffeab2"
                                    ></v-autocomplete>
                                </v-col>
                                <v-col cols="4" sm="4" class="mt-n2">
                                    <v-autocomplete
                                        outlined
                                        :label="$t('pmassementrecord.pmassessmentcalculationmethod')"
                                        type="text"
                                        ref="pmcalmethodid"
                                        v-model="formData[0].pmcalmethodid"
                                        :items="calculationMethodList"
                                        dense
                                        readonly
                                        background-color="#ffeab2"
                                    ></v-autocomplete>
                                </v-col>
                            </v-row>

                            <v-row class="mt-n4">
                                <v-col v-if="formData[0].threshold" cols="2" sm="2" class="mt-n2">
                                    <v-text-field
                                        outlined
                                        :label="$t('pmreviewexercisesectioncard.threshold')"
                                        type="number"
                                        ref="threshold"
                                        v-model="formData[0].threshold"
                                        dense
                                        readonly
                                        background-color="#ffeab2"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="2" sm="2" class="mt-n2">
                                    <v-text-field
                                        outlined
                                        :label="$t('columns.target')"
                                        type="number"
                                        ref="target"
                                        v-model="formData[0].target"
                                        dense
                                        readonly
                                        background-color="#ffeab2"
                                    ></v-text-field>
                                </v-col>
                                <v-col v-if="formData[0].stretch" cols="2" sm="2" class="mt-n2">
                                    <v-text-field
                                        outlined
                                        :label="$t('pmreviewexercisesectioncard.stretch')"
                                        type="number"
                                        ref="stretch"
                                        v-model="formData[0].stretch"
                                        dense
                                        readonly
                                        background-color="#ffeab2"
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                        </div>
                    </v-expansion-panel-content>
                </v-expansion-panel>
            </v-expansion-panels>

        <div v-if="isErr">  
            <app-error
                v-bind:parentError="{
                data: this.errMsg,
                isErr: this.isErr,
                }"
                v-on:closeError="isErr = $event"
            />
        </div>
    </div>
</template>

<script>
import ErrorDialog from "../../../components/common/ErrorDialog";

export default {
    props: {
        parentObject: Object
    },

    components: {
        "app-error": ErrorDialog,
    },

    data() {
        return {
            rules: {
                required: value => !!value || this.$t('reportsparam.required'),
            },

            commonkpi: this.parentObject.commonKPI,
            formData: {},

            targetOptionFull: [],
            targetOptionList: [],
            calculationMethodList: [],

            //error msg and dialog, check for duplicates vars
            isExisting: false,
            isErr: false,
            errMsg: '',
        }
    },

    methods: {
      
        loadCommonKPIDetails(){
            const vm = this;
            this.$store.dispatch('get', { url: "/kpicommon/details/" + vm.commonkpi.kpiexercmmkpiid })
            .then((res) => {
                vm.formData = res.data.rec;
                vm.formData.type = "Company";
                vm.formData.progress = vm.formData[0].progress || 0;
                this.changeTargetOption(vm.formData[0].pmtargetoptionid);
            }).catch((err) => {
                console.error(err);
            });
        },

        loadTargetOptionListHandler() {
            const vm = this;

            this.$store.dispatch('get', { url: '/kpitargetoption/all' })
            .then((res) => {

                vm.targetOptionFull = res.data.rec;

                for (let i = 0; i < res.data.rec.length; i++) {
                    
                    vm.targetOptionList.push({
                        text: res.data.rec[i].targetoption,
                        value: res.data.rec[i].id,
                    });
                }

            })
            .catch((err) => {
                vm.isErr = true;
                vm.errMsg = err;
                vm.$emit("error", { isErr: vm.isErr, errMsg: vm.errMsg });
            });
        },

        changeTargetOption(id) {
            let item = this.targetOptionFull.find((item) => item.id === id);
            this.formData.targetType = item.targetoption;
        },

        loadCalculationMethodListHandler() {
            const vm = this;
            this.$store.dispatch('get', { url: '/kpicalculationmethod/all' })
            .then((res) => {
                for (let i = 0; i < res.data.rec.length; i++) {
                    vm.calculationMethodList.push({
                        text: res.data.rec[i].calmethod,
                        value: res.data.rec[i].id,
                    });
                }
            })
            .catch((err) => {
                vm.isErr = true;
                vm.errMsg = err;
                vm.$emit("error", { isErr: vm.isErr, errMsg: vm.errMsg });
            });
        },
    },

    mounted() {
        this.loadTargetOptionListHandler();
        this.loadCalculationMethodListHandler();
        this.loadCommonKPIDetails();
    }
}
</script>

<style scoped>

.kpi-card-header {
    display: flex;
    flex-direction: column;
    gap: 2px;
    width: 100%;
    padding-right: 8px;
}

.kpi-card-top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
}

.kpi-card-type {
    font-size: 0.82rem;
    font-weight: 600;
    color: #37474f;
}

.kpi-card-weightage {
    font-size: 0.82rem;
    color: #546e7a;
    text-align: right;
}

.kpi-card-goal {
    font-size: 0.82rem;
    font-weight: 400;
    color: #546e7a;
}

.v-input .v-input__control .v-input__slot .v-text-field__slot input::-webkit-outer-spin-button,
.v-input .v-input__control .v-input__slot .v-text-field__slot input::-webkit-inner-spin-button
{
-webkit-appearance: none;
margin: 0;
}
</style>